import { h } from "preact";
import { BiSolidBadgeCheck } from "react-icons/bi";

const CredentialIssuerInfo = ({ displayData }) => {
  return (
    <>
      <article class="w-full rounded-lg bg-[#FFF] px-5 py-3 my-0 md:block">
        <p class="text-left font-sans text-[14px]">
          {
            displayData.credential.credentialSubject.achievement.criteria
              .narrative
          }
        </p>
      </article>
      <article class="w-full rounded-lg bg-[#fff] text-center px-5 py-3 grid grid-cols-3">
        <div class="col-span-3 text-left lg:col-span-3 lg:px-3">
          <p class="justify-start text-zinc-500 text-sm font-normal text-[14px]">
            Certificado emitido a:
          </p>
          <p class="font-sans text-xl lg:text-[20px]">
            {displayData.subject.name} {displayData.subject.last_name}
          </p>
        </div>
      </article>
      <article class="w-full rounded-lg bg-[#fff]">
        <div class="w-full rounded-lg bg-[#fff] px-5 py-4 md:mb-0 md:grid md:grid-cols-2 lg:grid-cols-3">
          <div class="md:col-span-1 md:mr-[15px] lg:col-span-2">
            <p class="text-sm text-[#858585] mb-2">Microcredencial Emitida</p>
            <p class="text-sm mb-4">{displayData.credential.name}</p>
            <p class="font-dm-sans text-sm text-[#858585] mb-2">
              Fecha de emisión
            </p>
            <p class="font-dm-sans text-sm mb-4">
              {new Date(displayData.credential.issuanceDate).toLocaleDateString(
                "es-ES",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                },
              )}
            </p>
          </div>
          <div class="md:col-span-1 lg:col-span-1 text-center">
            <img
              class="w-[122px] h-auto mx-auto mb-[10px] md:col-span-1"
              src={displayData.credential.badge.badgeLogo}
              alt="Logo"
            />
            <p class="text-sm text-[#858585] mb-2">Emitido por:</p>
            <div class="flex items-center justify-center">
              <img
                class="w-[30px] h-[30px] mr-2"
                src={displayData.issuer.logo_url}
                alt="Logo"
              />
              <p class="text-xs">{displayData.issuer.short_name}</p>
              <BiSolidBadgeCheck color="#60a5fa" class="w-5 h-5 ml-2" />
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default CredentialIssuerInfo;
